export default "__VITE_ASSET__7QzCKPXO__"